(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event){
  const swatch = event.target.closest('.family-swatch');
  if(!swatch) return;
  const card = swatch.closest('.product-card-wrapper');
  const rating = swatch.dataset.rating;
  card.querySelector('.card__image').src =swatch.dataset.image;
  card.querySelector('.card__image').srcset = swatch.dataset.image;
  card.querySelector('.card__simage').src =swatch.dataset.simage;
  card.querySelector('.card__simage').srcset = swatch.dataset.simage;
  card.querySelector('.card__desc').srcset = swatch.dataset.desc;
  card.querySelectorAll('.rating').forEach(item => {
    //item.style.display='none';
    item.style.setProperty("display", "none", "important");
  });
  //card.querySelector('.'+rating).style.display='block';
  card.querySelector('.'+rating).style.setProperty("display", "block", "important");
  card.querySelector('.CardLink').href = swatch.dataset.url;
  card.querySelector('.product__view-details').href =  swatch.dataset.url;
  card.querySelector('.price').textContent = swatch.dataset.price;
  card.querySelector('.family-card__flavor').textContent = swatch.dataset.flavor;
  card.querySelectorAll('.family-swatch').forEach(item => {
    item.classList.remove('active');
  });
  swatch.classList.add('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        document.querySelector('cart-drawer.drawer').classList.add('header--sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.querySelector('cart-drawer.drawer').classList.add('header--sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      document.querySelector('cart-drawer.drawer').classList.add('header--sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.querySelector('cart-drawer.drawer').classList.remove('header--sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event){
  const swatch = event.target.closest('.family-swatch');
  if(!swatch) return;
  const card = swatch.closest('.product-card-wrapper');
  const rating = swatch.dataset.rating;
  card.querySelector('.card__image').src =swatch.dataset.image;
  card.querySelector('.card__image').srcset = swatch.dataset.image;  
  card.querySelector('.card__desc').srcset = swatch.dataset.desc;
  card.querySelectorAll('.rating').forEach(item => {
    item.style.setProperty("display", "none", "important");
  });
  card.querySelector('.'+rating).style.setProperty("display", "block", "important");
  card.querySelector('.CardLink').href = swatch.dataset.url;
  card.querySelector('.product__view-details').href =  swatch.dataset.url;
  card.querySelector('.price').textContent = swatch.dataset.price;
  card.querySelector('.family-card__flavor').textContent = swatch.dataset.flavor;
  card.querySelectorAll('.family-swatch').forEach(item => {
    item.classList.remove('active');
  });
  swatch.classList.add('active');
});

  } catch(e) { console.error(e); }
})();
})();
